import { FC } from 'react'

// eslint-disable-next-line import/no-extraneous-dependencies
import { Callout } from 'baby-design'

export type ThirdPartyCalloutProps = {
  orderNumber: string | undefined | null
  name: string
}

const ThirdPartyCallout: FC<ThirdPartyCalloutProps> = ({
  orderNumber,
  name,
}) => {
  if (orderNumber) {
    return (
      <Callout
        backgroundColor="grey"
        text={`Contact ${name} for tracking & returns information.`}
        title="Tracking not available"
        variant="multi-line"
      />
    )
  }

  return (
    <Callout
      backgroundColor="grey"
      text={`Contact ${name} for order, tracking, and returns information.`}
      title="Order details not available"
      variant="multi-line"
    />
  )
}

export default ThirdPartyCallout
